module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Fork-spoon-0f693772de4c5aa6c4b3950241410746.svg";